import { SpinnerIos16Filled } from '@fluentui/react-icons'
export default function SpinnerLoader() {
    return (
        <SpinnerIos16Filled fontSize={16} className='animate animate-spin' />


    )
}
